import { SPEDIZIONI_FILTERED } from "./constants";
import { get, post, put } from "./service";

/**
 * Function to fetch all the users.
 */
export const getSpedizioniFiltered = async (filters, page_number, elements_count) => {
  return post(SPEDIZIONI_FILTERED(page_number, elements_count), filters);
};